(function() {
    angular
        .module("app")
        .factory("metaService", metaService)

    metaService.$inject = []

    function metaService() {

        var title = "WANCO"

        return {
            title: function() { return title },
            setTitle: function(newTitle) { title = newTitle }
        }
    }
})()
